import { db } from "@/shared/firbase";
import {
  addDoc,
  collection,
  doc,
  DocumentData,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../Loading";
import { Body, StImage, StLastImage } from "./style";
import { useTranslation } from "react-i18next";
import Header from "@/components/Header/Index";

const GamePlay = () => {
  const { name, select } = useParams();
  // 첫 게임 준비 배열
  const [startArr, setStartArr] = useState<DocumentData[]>([]);
  const dbWinner = collection(db, `${name}-rank`);
  // db
  const dbCollection = collection(db, String(name));
  const { t } = useTranslation();

  // navigate
  const navigate = useNavigate();

  // 시작배열에 파이어베이스 db에서 랜덤으로 가져올 함수
  const getData = async () => {
    //  데이터베이스에서 가져오기
    const data = await getDocs(dbCollection);
    //  가져와서 배열에 집어넣기
    setStartArr(
      data.docs
        .map((doc) => doc.data())
        .sort(() => Math.random() - 0.5)
        .slice(0, Number(select))
    );
  };
  //  클릭 이벤트
  const onClickHandler = (e: any) => () => {
    //클릭하면, 클릭한게 starArr 제일 뒤로 그리고 앞에서 두개 자르기
    setStartArr([...startArr, e].slice(2, startArr.length + 1));
  };

  //  처음에 데이터 가져오기
  useEffect(() => {
    getData();
  }, []);

  // 랜덤으로 가져온거 중에 2개를 display 하기
  const rendering = () => {
    const result = [];
    for (let i = 0; i < 2; i++) {
      result.push(
        <div className="flexCol" key={i}>
          <StImage
            pic={startArr[i]?.url}
            onClick={onClickHandler(startArr[i])}
          />
          <p>{t(startArr[i]?.name)}</p>
        </div>
      );
    }
    return result;
  };

  // 마지막 카드
  const lastRendering = () => {
    const result = [];
    result.push(
      <div className="flexDiv" key="winner">
        <div className="flexCol">
          <StLastImage pic={startArr[0]?.url} />
          <p>
            {t("우승자")} {t(startArr[0]?.name)}
          </p>
        </div>
        <div className="flexCol">
          <button onClick={() => navigate("/")}>{t("다른 게임 하기")}</button>

          <button onClick={() => navigate(`/rank/${name}`)}>
            {t("이상형의 랭킹!")}
          </button>
        </div>
      </div>
    );
    return result;
  };

  // 우승로직 함수
  const winner = async () => {
    //  만약에 시작 배열의 길이가 1이면
    if (startArr.length === 1) {
      const data = await getDocs(dbWinner);
      const tempArr = data.docs.map((doc) => ({
        data: doc.data(),
        id: doc.id,
      }));
      // 만약에 시작배열이 아무것도 없으면 db에 집어넣기
      if (tempArr.length === 0) {
        await addDoc(dbWinner, {
          name: startArr[0]?.name,
          url: startArr[0]?.url,
          count: 1,
        });
        //  만약에 시작배열에 무언가가 들어있을경우 => 업데이트 인지 새로만드는건지 고민
      } else {
        // db안의 rank name을 담을 배열
        const arr: string[] = [];
        // db안을 돌면서 배열에 name을 넣어줌
        tempArr.map(async (v, i) => {
          arr.push(v.data.name);
          // 만약에 db안의 이름과, 우승자 이름이 같으면 있는거니까 count + 1
          if (v.data.name === startArr[0].name) {
            const updateData = doc(db, `${name}-rank`, v.id);
            await updateDoc(updateData, { count: v.data.count + 1 });
          }
        });
        // 만약에 db안에 우승자 이름이 없으면, 새 데이터니까 db에 데이터 생성
        if (!arr.includes(startArr[0].name)) {
          await addDoc(dbWinner, {
            name: startArr[0]?.name,
            url: startArr[0]?.url,
            count: 1,
          });
        }
      }
    }
  };

  // 우승로직을 db에 보내기
  useEffect(() => {
    winner();
  }, [startArr]);

  const Round = () => {
    switch (true) {
      case startArr.length < 65 && startArr.length > 32:
        return (
          <div className="title">
            {t(`${name}`)} - 64 {t(`강`)}
          </div>
        );
      case startArr.length < 33 && startArr.length > 16:
        return (
          <div className="title">
            {t(`${name}`)} - 32 {t(`강`)}
          </div>
        );
      case startArr.length < 17 && startArr.length > 8:
        return (
          <div className="title">
            {t(`${name}`)} - 16 {t(`강`)}
          </div>
        );
      case startArr.length < 9 && startArr.length > 4:
        return (
          <div className="title">
            {t(`${name}`)} - 8 {t(`강`)}
          </div>
        );
      case startArr.length < 5 && startArr.length > 2:
        return (
          <div className="title">
            {t(`${name}`)} - 4 {t(`강`)}
          </div>
        );
      case startArr.length < 3:
        return (
          <div className="title">
            {t(`${name}`)} - {t(`결승`)}
          </div>
        );
      default:
        return;
    }
  };

  return (
    <>
      <Header />
      <Body>
        {startArr.length === 0 ? (
          <Loading />
        ) : (
          <div>
            {Round()}
            <div className="flexDiv">
              {/* 우승 로직 */}
              {startArr.length !== 1 ? rendering() : lastRendering()}
            </div>
          </div>
        )}
      </Body>
    </>
  );
};

export default GamePlay;
